var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"cool-picker",attrs:{"id":"picker"}})
}
var staticRenderFns = []

export { render, staticRenderFns }